/**
 * @file Handles magic padlet logic.
 * */
import { __ } from '@@/bits/intl'

const EXAMPLE_PROMPTS = [
  __('8 fun ideas to celebrate Earth Day with my class of 5th graders.'),
  __(
    'a list of 10 popular travel destinations grouped according to the type of travel. Include an interesting historical fact about each location.',
  ),
  __('a typical day in the life of a monk living in a Zen Buddhist monastery in Japan.'),
  __('a chronological list of the 8 most important points in the evolution of humans, written for 12th graders.'),
  __('a map of the 12 most loved national parks in the world'),
  __('12 fictional books that I could study with my 11th grade students. Include the themes of each book.'),
  __(
    'six statements about the book Nineteen Eighty-Four by George Orwell that 8th grade students could write a medium length essay about.',
  ),
  __(
    'an empty template for first-year biology students to summarize concepts learned in lab, ask questions, and share resources.',
  ),
  __('a ranked list of the top 10 most impressive inventions and their history, written for 12th graders.'),
  __('eight fun lesson ideas to teach my 2nd grade class about dinosaurs.'),
  __(
    'a chronological list of the most important events in the Three Kingdoms period of China, with the year included in the post title. Include at least 9 posts.',
  ),
  __(
    'seven fun science experiment ideas I can try with my class of 5th graders. Include what can be learnt from each.',
  ),
  __('15 books that I can recommend to my 10th grade students to read over the summer'),
  __(
    'eight ideas for a craft activity that I can do with my class of 1st graders to create something for mothers day.',
  ),
  __('four columns for students to vote on how they found the class. Each column will represent their mood'),
]

const FIXED_ROLE = 'teacher'

const GRADES = ['K', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', 'Higher Ed.']

const isHigherEd = (grade: string): boolean => grade === 'Higher Ed.'

const getRoleAndRandomPrompt = (): { role: string; prompt: string; index: number } => {
  const randomIndex = Math.floor(Math.random() * EXAMPLE_PROMPTS.length)
  const randomPrompt = EXAMPLE_PROMPTS[randomIndex]

  return {
    role: FIXED_ROLE,
    prompt: randomPrompt,
    index: randomIndex,
  }
}

const getNextPrompt = (index: number): { prompt: string; index: number } => {
  const nextIndex = index === EXAMPLE_PROMPTS.length - 1 ? 0 : index + 1
  return {
    prompt: EXAMPLE_PROMPTS[nextIndex],
    index: nextIndex,
  }
}

function isExamplePrompt(prompt: string): boolean {
  return EXAMPLE_PROMPTS.includes(prompt)
}

export { GRADES, getNextPrompt, getRoleAndRandomPrompt, isExamplePrompt, isHigherEd }
